import { DEFAULT_PRODUCT_VALUE, DEFAULT_SORT, SECTION_TYPES } from './shared/configs';

const { JAPAN, HENSHUCHO } = SECTION_TYPES;

const baseQuery = {
  query: {
    and: [
      { terms: { key: 'Product', value: DEFAULT_PRODUCT_VALUE } },
      { terms: { key: 'SectionType', value: [JAPAN, HENSHUCHO] } }
    ]
  },
  ...DEFAULT_SORT
};

export { baseQuery as MAIN };
